
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Penerima', value: 'data_receiver', width: '300'},
  { text: 'Subject', value: 'subject'},
  { text: 'Broadcast Date', value: 'broadcast_date'},
  { text: 'Created Date', value: 'created_at'},
  { text: 'Created By', value: 'created_by'},
  { text: 'Action', value: 'action', width: '100' }
]);

export const dataDelayServiceHit = 500;

export const search = {
  subject: '',
  created_at: null,
  email: '',
  broadcast_date: null,
  created_by: '',
};

